interface ElementConfig {
  tag: string;
  style: Record<string, string>;
}

export function generateHtmlElement(config: ElementConfig) {
  const element = document.createElement(config.tag);
  const attributes = Object.keys(config);

  attributes.forEach((attribute: string) => {
    if (attribute === 'style') {
      const styleAattributes = Object.keys(config.style);

      styleAattributes.forEach((styleAattribute) => {
        try {
          // @ts-ignore this code attempts to assign properties that are potentially read-only. Added try-catch to handle it.
          element.style[styleAattribute as keyof HTMLElement['style']] = config.style[styleAattribute];
        } catch (e) {
          // noop
        }
      });
    } else {
      try {
        // @ts-ignore this code attempts to assign properties that are potentially read-only. Added try-catch to handle it.
        element[attribute as keyof HTMLElement] = config[attribute];
      } catch (e) {
        // noop
      }
    }
  });

  return element;
}

export function isReadyToInjectScript() {
  return typeof document !== 'undefined' && typeof window !== 'undefined';
}

function stripNewLines(str: string) {
  return str.replace(/(\r\n|\n|\r)/gm, '');
}

export function generateGtmScriptContents(id: string) {
  return stripNewLines(`
(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${id}');`);
}

export function generateGtmNoscriptContents(id: string) {
  return `<iframe src="https://www.googletagmanager.com/ns.html?id=${id}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`;
}

export function generateUaScriptContents(id: string, name: string, url: string, options: string | unknown = 'auto') {
  return stripNewLines(`
(function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
(i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
})(window,document,'script','${url}','ga');
ga('create', '${id}', 'auto',  '${name}', '${options}');`);
}
